import type { AllFilters, ClaimsTableColumnSetting } from '../../types/claims';
import type { OrderBy } from '../../stores/ClaimsStore';
import { parseAllFilters, parseOrderBy } from './claimsFiltersStorage';
import { readTenantFilters, writeTenantFilters } from './filtersTenantStorage';

// One localStorage blob for the home page's "Your Claims" table: its keyword
// search, column filters, sort and column settings (visibility + pin). Separate from "filters:claims" so narrowing
// the home table never changes what /claims shows. Stored per tenant and user,
// see filtersTenantStorage.
export const HOME_CLAIMS_FILTERS_STORAGE_KEY = 'filters:home';

export interface PersistedHomeClaimsFilters {
  keywordSearch: string;
  filters: AllFilters | null;
  /** undefined = nothing saved (keep the default sort); null = sorting cleared. */
  orderBy?: OrderBy | null;
  /** null = never saved (use the defaults). */
  columnSettings: ClaimsTableColumnSetting[] | null;
}

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  value != null && typeof value === 'object' && !Array.isArray(value);

export const loadPersistedHomeClaimsFilters = (scope: string | null): PersistedHomeClaimsFilters => {
  const saved = readTenantFilters(HOME_CLAIMS_FILTERS_STORAGE_KEY, scope);
  const blob = isPlainObject(saved) ? saved : {};

  return {
    keywordSearch: typeof blob.keywordSearch === 'string' ? blob.keywordSearch : '',
    filters: parseAllFilters(blob.filters),
    orderBy: parseOrderBy(blob.orderBy),
    columnSettings: Array.isArray(blob.columnSettings) ? (blob.columnSettings as ClaimsTableColumnSetting[]) : null,
  };
};

export const savePersistedHomeClaimsFilters = (scope: string | null, filters: PersistedHomeClaimsFilters): void => {
  writeTenantFilters(HOME_CLAIMS_FILTERS_STORAGE_KEY, scope, filters);
};
